import { render, staticRenderFns } from "./Demonstration.vue?vue&type=template&id=73c6073f&scoped=true&"
import script from "./Demonstration.vue?vue&type=script&lang=js&"
export * from "./Demonstration.vue?vue&type=script&lang=js&"
import style0 from "./Demonstration.vue?vue&type=style&index=0&id=73c6073f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c6073f",
  null
  
)

export default component.exports